import { Direction } from "../../../../types/battle-engine/battle";
import { SkillCastPattern } from ".";

export const SQUARE_2_PATTERN: SkillCastPattern = () => {
  return {
    [Direction.N]: [
      [-1, 0],
      [0, -1],
      [0, 1],
      [1, 0],
      [-1, -1],
      [-1, 1],
      [1, -1],
      [1, 1],
      [-2, 0],
      [0, -2],
      [0, 2],
      [2, 0],
      [-2, -1],
      [-2, 1],
      [-1, -2],
      [-1, 2],
      [1, -2],
      [1, 2],
      [2, -1],
      [2, 1],
    ],

    [Direction.NE]: [],

    [Direction.E]: [
      [-1, 0],
      [0, -1],
      [0, 1],
      [1, 0],
      [-1, -1],
      [-1, 1],
      [1, -1],
      [1, 1],
      [-2, 0],
      [0, -2],
      [0, 2],
      [2, 0],
      [-2, -1],
      [-2, 1],
      [-1, -2],
      [-1, 2],
      [1, -2],
      [1, 2],
      [2, -1],
      [2, 1],
    ],

    [Direction.SE]: [],

    [Direction.S]: [],

    [Direction.SW]: [],

    [Direction.W]: [],

    [Direction.NW]: [],
  };
};
